// Module
var code = "<section class=\"cr-quicksight-embed\"> <h2>{{ ::$ctrl.text.quicksightDashboard }}</h2> <div ng-if=\"!$ctrl.enabled\">{{ ::$ctrl.text.disabledMessage }}</div> <div id=\"quicksight-embed-container\"> <div id=\"quicksight-embed-target\"></div> </div> </section> ";
// Exports
export default code;